import { ICallRefinement } from '../interfaces/self-serve/icall-refinement';

const STORAGE_KEY = 'self_serve_call_refinements';

export const CallRefinementLocalStorageUtil = {
  getAll(): ICallRefinement[] {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (err) {
      console.error('Failed to parse call refinements:', err);
      return [];
    }
  },

  saveAll(refinements: ICallRefinement[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(refinements));
    } catch (err) {
      console.error('Failed to save call refinements:', err);
    }
  },
};
